import styled from "styled-components"
import { Modal } from "react-bootstrap"
import { useMemo } from "react"
import Table from "./Table"
import Box from "~/components/UI/Box"
import Icon from "~/components/UI/Icon"
import Link from '~/components/UI/Link'

interface Props {
  contentIndex: number //1 | 2 | 3
  show: boolean
  handleClose: () => void
}

const StyledModal = styled(Modal)`
  .modal-content {
    border: none;
  }
`

const Popup: React.FC<Props> = ({ contentIndex, show, handleClose }) => {

  const content = useMemo(() => {
    return <Table contentIndex={contentIndex} />
  }, [contentIndex])

  const onClose = (evt: any) => {
    evt.preventDefault()
    handleClose()
  }

  return (
    <StyledModal centered size="lg" show={show} onHide={handleClose}>
      <Modal.Title style={{ textAlign: 'right', padding: 10 }}>
        <Link onClick={onClose} href='#' style={{ color: '#000' }}>
          <Icon style={{ fontSize: 28 }} name='exit' />
        </Link>
      </Modal.Title>
      <Modal.Body>
        <Box padding='0 0 40px 0'>
          {content}
        </Box>
      </Modal.Body>
    </StyledModal>
  )
}

export default Popup
